export type InterviewStatusValues =
  | 'WAITING_MENTEE'
  | 'WAITING_MENTOR'
  | 'REFUSED'
  | 'ACCEPTED'
  | 'WAITING_REVIEW'
  | 'FINISHED'
  | 'CANCELLED'
  | 'LATE'
  | 'NO_ANSWER';

/**
 * Pour le Mentor
 */
export const INTERVIEW_STATUS_MENTOR = {
  WAITING_MENTEE: 'Pas encore accepté',
  WAITING_MENTOR: 'Votre réponse est attendue',
  WAITING_REVIEW: 'En attente du compte-rendu',
  NO_ANSWER: 'Sans réponse',
  REFUSED: 'Refusé',
  ACCEPTED: 'Accepté',
  FINISHED: 'Compte-rendu rempli',
  CANCELLED: 'Annulé',
};

export const getMenteeStatusLabel = (status: InterviewStatusValues, isAuthor: boolean): string => {
  if (status === 'WAITING_MENTOR') {
    return isAuthor ? 'En attente du mentor' : 'En attente de votre réponse';
  }
  if (status === 'WAITING_MENTEE') {
    return isAuthor ? 'En attente du mentoré' : 'En attente de votre réponse';
  }

  // 2. Mapping des autres statuts
  const labels: Record<string, string> = {
    WAITING_REVIEW: 'En attente du compte-rendu',
    NO_ANSWER: isAuthor ? "Le mentor n'a pas répondu" : "Vous n'avez pas répondu",
    REFUSED: 'Refusé',
    ACCEPTED: 'Accepté',
    FINISHED: 'Compte-rendu rempli',
    CANCELLED: 'Annulé',
    LATE: 'Entretien passé (en attente)',
    WAITING_MENTOR: 'En attente du mentor',
    WAITING_MENTEE: 'En attente du mentoré',
  };

  // 3. Retourne le label ou le code brut par défaut
  return labels[status] || status;
};

// Statuts par défaut (Admin ou général)
const INTERVIEW_STATUS = {
  WAITING_MENTEE: 'Pas encore accepté',
  WAITING_MENTOR: 'En attente du mentor',
  WAITING_REVIEW: 'En attente du compte-rendu',
  NO_ANSWER: 'Sans réponse',
  REFUSED: 'Refusé',
  ACCEPTED: 'Accepté',
  FINISHED: 'Comptes-rendus remplis',
  CANCELLED: 'Annulé',
};

export default INTERVIEW_STATUS;